/* INTERHOUSE - bendri sąveikos elementai */
(function () {
  'use strict';

  /* 1. pasirodymas slenkant */
  function rise() {
    var els = document.querySelectorAll('.ih-rise:not(.in)');
    if (!els.length) return;
    if (!('IntersectionObserver' in window)) {
      Array.prototype.forEach.call(els, function (e) { e.classList.add('in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (!en.isIntersecting) return;
        var d = en.target.getAttribute('data-d');
        if (d) en.target.style.transitionDelay = d + 'ms';
        en.target.classList.add('in');
        io.unobserve(en.target);
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.06 });
    Array.prototype.forEach.call(els, function (e) { io.observe(e); });
  }

  /* 2. užklausos forma: ploto slankiklis + tipo chipsai */
  function form() {
    var boxes = document.querySelectorAll('.ih-formbox');
    Array.prototype.forEach.call(boxes, formOne);
  }

  function formOne(box) {
    var range = box.querySelector('.ihf-range');
    var out = box.querySelector('.ihf-area-val');
    var hid = box.querySelector('.ihf-area-input');
    if (range && out) {
      var paint = function () {
        var v = +range.value;
        out.textContent = v;
        if (hid) hid.value = v;
        var p = (v - range.min) / (range.max - range.min) * 100;
        range.style.setProperty('--p', p + '%');
      };
      range.addEventListener('input', paint);
      paint();
    }

    var chips = box.querySelectorAll('.ihf-chip input');
    Array.prototype.forEach.call(chips, function (c) {
      c.addEventListener('change', function () {
        Array.prototype.forEach.call(chips, function (x) {
          x.closest('.ihf-chip').setAttribute('aria-checked', x.checked ? 'true' : 'false');
        });
      });
    });

    /* užpildytų laukų žymėjimas (plaukiojančios etiketės) */
    var fields = box.querySelectorAll('.ihf-f input, .ihf-f textarea');
    Array.prototype.forEach.call(fields, function (f) {
      var mark = function () { f.closest('.ihf-f').classList.toggle('has', !!f.value); };
      f.addEventListener('input', mark);
      f.addEventListener('blur', mark);
      mark();
    });

    /* jei forma buvo išsiųsta arba yra klaida - nuvedam prie jos */
    if (box.querySelector('.ihf-msg')) {
      setTimeout(function () {
        box.querySelector('.ihf-msg').scrollIntoView({ behavior: 'smooth', block: 'center' });
      }, 250);
    }
  }

  /* 3. video juostos paleidimas paspaudus */
  function video() {
    Array.prototype.forEach.call(document.querySelectorAll('.ihv'), function (w) {
      var btn = w.querySelector('.ihv-play');
      var v = w.querySelector('video');
      if (!btn || !v) return;
      btn.addEventListener('click', function () {
        w.classList.add('playing');
        v.controls = true;
        v.play();
      });
    });
  }

  function init() { rise(); form(); video(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();
